// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   CONTACTANOS - ESTILOS
   ========================================================================== */

.contact-page {
  min-height: 75vh;
  padding: 40px 20px 80px;
}

.contact-wrapper {
  max-width: 900px;
  margin: 0 auto;
}

/* Header */
.contact-header {
  text-align: center;
  margin-bottom: 35px;
}

.contact-title {
  font-size: 2rem;
  font-weight: 700;
  color: #111111;
  margin-bottom: 10px;
}

.contact-subtitle {
  font-size: 1.05rem;
  color: #6c757d;
  margin: 0 auto;
  max-width: 600px;
}

/* Grilla */
.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

/* Card base */
.contact-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e9ecef;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  padding: 24px;
  display: flex;
  flex-direction: column;
}

.card-section-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1a1a1a;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f1f3f5;
}

.card-section-title i {
  color: var(--color-principal, #E00202);
  font-size: 1.3rem;
}

/* Items */
.contact-items {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  border-radius: 10px;
  text-decoration: none;
  color: inherit;
  transition: all 0.2s ease;
}

.contact-item-link {
  background-color: #f8f9fa;
  border: 1px solid #eef0f2;
}

.contact-item-link:hover {
  background-color: #ffffff;
  border-color: #dee2e6;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  transform: translateY(-1px);
}

.static-item {
  background-color: #f8f9fa;
  border: 1px solid #eef0f2;
  align-items: flex-start;
}

/* Icon Boxes */
.item-icon-box {
  width: 42px;
  height: 42px;
  min-width: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
}

.whatsapp-box {
  background-color: rgba(37, 211, 102, 0.15);
  color: #25D366;
}

.mail-box {
  background-color: rgba(234, 67, 53, 0.15);
  color: #EA4335;
}

.location-box {
  background-color: rgba(224, 2, 2, 0.12);
  color: var(--color-principal, #E00202);
}

.time-box {
  background-color: rgba(13, 110, 253, 0.12);
  color: #0d6efd;
}

/* Item Text */
.item-info {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.item-label {
  font-size: 0.8rem;
  color: #888888;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.item-value {
  font-size: 1rem;
  font-weight: 600;
  color: #212529;
  margin-top: 1px;
}

.item-subvalue {
  font-size: 0.9rem;
  color: #6c757d;
  margin-top: 2px;
}

.item-arrow {
  font-size: 1.3rem;
  color: #adb5bd;
  transition: transform 0.2s ease, color 0.2s ease;
}

.contact-item-link:hover .item-arrow {
  color: #212529;
  transform: translateX(3px);
}

/* Maps Button */
.maps-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--color-principal, #E00202);
  text-decoration: none;
  transition: opacity 0.2s;
}

.maps-btn:hover {
  opacity: 0.8;
  text-decoration: underline;
}

/* Social Section */
.social-section {
  margin-top: 4px;
  padding-top: 10px;
}

.social-label {
  display: block;
  font-size: 0.8rem;
  color: #888888;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 10px;
}

.social-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.social-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
}

.instagram-btn {
  background-color: rgba(193, 53, 132, 0.08);
  color: #C13584;
  border: 1px solid rgba(193, 53, 132, 0.2);
}

.instagram-btn:hover {
  background-color: #C13584;
  color: #ffffff;
}

.facebook-btn {
  background-color: rgba(24, 119, 242, 0.08);
  color: #1877F2;
  border: 1px solid rgba(24, 119, 242, 0.2);
}

.facebook-btn:hover {
  background-color: #1877F2;
  color: #ffffff;
}

/* ==========================================================================
   RESPONSIVE
   ========================================================================== */
@media (max-width: 768px) {
  .contact-page {
    padding: 30px 15px 50px;
  }

  .contact-title {
    font-size: 1.65rem;
  }

  .contact-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .contact-card {
    padding: 18px;
  }

  .social-buttons {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/contactanos/contactanos.component.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ==========================================================================\n   CONTACTANOS - ESTILOS\n   ========================================================================== */\n\n.contact-page {\n  min-height: 75vh;\n  padding: 40px 20px 80px;\n}\n\n.contact-wrapper {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n/* Header */\n.contact-header {\n  text-align: center;\n  margin-bottom: 35px;\n}\n\n.contact-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #111111;\n  margin-bottom: 10px;\n}\n\n.contact-subtitle {\n  font-size: 1.05rem;\n  color: #6c757d;\n  margin: 0 auto;\n  max-width: 600px;\n}\n\n/* Grilla */\n.contact-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n/* Card base */\n.contact-card {\n  background: #ffffff;\n  border-radius: 12px;\n  border: 1px solid #e9ecef;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n}\n\n.card-section-title {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #1a1a1a;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 20px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #f1f3f5;\n}\n\n.card-section-title i {\n  color: var(--color-principal, #E00202);\n  font-size: 1.3rem;\n}\n\n/* Items */\n.contact-items {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.contact-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  text-decoration: none;\n  color: inherit;\n  transition: all 0.2s ease;\n}\n\n.contact-item-link {\n  background-color: #f8f9fa;\n  border: 1px solid #eef0f2;\n}\n\n.contact-item-link:hover {\n  background-color: #ffffff;\n  border-color: #dee2e6;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);\n  transform: translateY(-1px);\n}\n\n.static-item {\n  background-color: #f8f9fa;\n  border: 1px solid #eef0f2;\n  align-items: flex-start;\n}\n\n/* Icon Boxes */\n.item-icon-box {\n  width: 42px;\n  height: 42px;\n  min-width: 42px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.4rem;\n}\n\n.whatsapp-box {\n  background-color: rgba(37, 211, 102, 0.15);\n  color: #25D366;\n}\n\n.mail-box {\n  background-color: rgba(234, 67, 53, 0.15);\n  color: #EA4335;\n}\n\n.location-box {\n  background-color: rgba(224, 2, 2, 0.12);\n  color: var(--color-principal, #E00202);\n}\n\n.time-box {\n  background-color: rgba(13, 110, 253, 0.12);\n  color: #0d6efd;\n}\n\n/* Item Text */\n.item-info {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.item-label {\n  font-size: 0.8rem;\n  color: #888888;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.item-value {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #212529;\n  margin-top: 1px;\n}\n\n.item-subvalue {\n  font-size: 0.9rem;\n  color: #6c757d;\n  margin-top: 2px;\n}\n\n.item-arrow {\n  font-size: 1.3rem;\n  color: #adb5bd;\n  transition: transform 0.2s ease, color 0.2s ease;\n}\n\n.contact-item-link:hover .item-arrow {\n  color: #212529;\n  transform: translateX(3px);\n}\n\n/* Maps Button */\n.maps-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--color-principal, #E00202);\n  text-decoration: none;\n  transition: opacity 0.2s;\n}\n\n.maps-btn:hover {\n  opacity: 0.8;\n  text-decoration: underline;\n}\n\n/* Social Section */\n.social-section {\n  margin-top: 4px;\n  padding-top: 10px;\n}\n\n.social-label {\n  display: block;\n  font-size: 0.8rem;\n  color: #888888;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  margin-bottom: 10px;\n}\n\n.social-buttons {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.social-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.2s ease;\n}\n\n.instagram-btn {\n  background-color: rgba(193, 53, 132, 0.08);\n  color: #C13584;\n  border: 1px solid rgba(193, 53, 132, 0.2);\n}\n\n.instagram-btn:hover {\n  background-color: #C13584;\n  color: #ffffff;\n}\n\n.facebook-btn {\n  background-color: rgba(24, 119, 242, 0.08);\n  color: #1877F2;\n  border: 1px solid rgba(24, 119, 242, 0.2);\n}\n\n.facebook-btn:hover {\n  background-color: #1877F2;\n  color: #ffffff;\n}\n\n/* ==========================================================================\n   RESPONSIVE\n   ========================================================================== */\n@media (max-width: 768px) {\n  .contact-page {\n    padding: 30px 15px 50px;\n  }\n\n  .contact-title {\n    font-size: 1.65rem;\n  }\n\n  .contact-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .contact-card {\n    padding: 18px;\n  }\n\n  .social-buttons {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
